// extracted by mini-css-extract-plugin
export default {"html":"styles_html__9TWUQ","imgModal":"styles_imgModal__tLa25","modal":"styles_modal__hfBTV","shadow":"styles_shadow__qNLx6","close":"styles_close__sRoGS"};